import React from "react";
import "./header.css";
import { Animation } from "../../Assets";
import Fade from "react-reveal/Fade";

const Header = () => {
  return (
    <div className="Header_Image_background" id="Header_Section">
      <div className="Swap_Main_Content_Container">
        <Fade left>
          <div className="Swap_Main_Content_Wrapper">
            <p className="header_Defi_style">DeFi Swap - Reimagined</p>
            <p className="header_Swap_Style">
              Swap smarter, not harder - with the most advanced and
              user-friendly DeFi Swap platform
            </p>
            <button className="Swap_Button_Style">Start Swapping Now!</button>
          </div>
        </Fade>
        <Fade right>
          <div className="Animation_Image_Container">
            <img
              src={Animation}
              alt="image"
              className="Animation_image_Style"
            />
          </div>
        </Fade>
      </div>
      <Fade bottom>
        <div className="Swap_Header_Fade_Border_Style_container">
          <div className="Swap_Header_Fade_Border_Style">
            <div className="Swap_Fade_Text_Wrapper">
              <p className="Swap_Header_Fade_Text_Style">345</p>
              <div className="Swap_Header_Fade_SubText_Style">
                Liquidity sources
              </div>
            </div>
            <div className="Swap_Fade_Text_Wrapper">
              <p className="Swap_Header_Fade_Text_Style">$281B+</p>
              <div className="Swap_Header_Fade_SubText_Style">Total volume</div>
            </div>
            <div className="Swap_Fade_Text_Wrapper">
              <p className="Swap_Header_Fade_Text_Style">4.4M+</p>
              <div className="Swap_Header_Fade_SubText_Style">
                Total wallets
              </div>
            </div>
            <div className="Swap_Fade_Text_Wrapper">
              <p className="Swap_Header_Fade_Text_Style">28.7M+</p>
              <div className="Swap_Header_Fade_SubText_Style">Total trades</div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default Header;
